/** Duration of drawer slide-in/slide-out animation (ms) */
export const DRAWER_SLIDE_ANIMATION_DURATION_MS = 300

/** Duration of drawer slide-in/slide-out animation for CSS (derived from ms) */
export const DRAWER_SLIDE_ANIMATION_DURATION_S = `${(DRAWER_SLIDE_ANIMATION_DURATION_MS / 1000).toFixed(1)}s`

/** Duration for state machine timer-based transitions (ms) */
export const TRANSITION_DURATION_MS = 2000
